export const heroData = {
  title: '今日热点大瓜',
  subtitle: '独家速报',
  description: '网红翻车第一现场，擦边反差真实还原，明星黑料深度追踪。24小时不间断更新，让你永远站在吃瓜第一线。',
  ctaText: '进入吃瓜现场',
  ctaLink: '/category/wanghong-fanche',
  image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20scene%20with%20dramatic%20warm%20spotlight%20on%20a%20microphone%20on%20stage%2C%20deep%20shadows%2C%20mysterious%20atmosphere%2C%20journalism%20investigation%20vibe%2C%20rich%20amber%20and%20burgundy%20tones%2C%20photographic%20texture%2C%20editorial%20style%2C%20no%20people%2C%20abstract%20storytelling%20visual&width=1600&height=800&seq=hero-main-2026-x1&orientation=landscape',
};

export const hotTopics = [
  {
    id: 'topic-1',
    title: '某顶流网红被曝私生活混乱',
    subtitle: '多位知情人实名爆料',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20portrait%20silhouette%20of%20a%20person%20behind%20frosted%20glass%20with%20warm%20amber%20light%20leaking%20through%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20deep%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20no%20visible%20face%2C%20abstract%20investigative%20mood&width=800&height=800&seq=topic-card-01&orientation=squarish',
    link: '/article/wanghong-sishenghuo',
  },
  {
    id: 'topic-2',
    title: '知名女星深夜密会神秘男子',
    subtitle: '独家偷拍画面首次曝光',
    image: 'https://readdy.ai/api/search-image?query=Dark%20alleyway%20at%20night%20with%20warm%20street%20lamp%20glow%2C%20mysterious%20shadowy%20figures%20in%20distance%2C%20cinematic%20noir%20style%2C%20rich%20amber%20and%20deep%20brown%20tones%2C%20film%20grain%20texture%2C%20investigative%20journalism%20aesthetic%2C%20no%20identifiable%20faces&width=800&height=800&seq=topic-card-02&orientation=squarish',
    link: '/article/nvxing-mihui',
  },
  {
    id: 'topic-3',
    title: '大主播带货翻车粉丝集体维权',
    subtitle: '涉事金额高达数千万元',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20shattered%20glass%20on%20dark%20surface%20with%20warm%20golden%20light%20reflecting%2C%20metaphor%20for%20broken%20trust%2C%20cinematic%20lighting%2C%20deep%20burgundy%20and%20amber%20contrast%2C%20editorial%20photography%2C%20abstract%20concept%2C%20high%20detail%20texture&width=800&height=800&seq=topic-card-03&orientation=squarish',
    link: '/article/zhubo-fanche',
  },
];

export const deepDiveSection = {
  title: '黑料',
  titleLine2: '挖掘机',
  description: '深度追踪每一条线索，还原事件真相。我们的记者团队7×24小时蹲守，不放过任何一个细节。',
  featured: {
    title: '独家：某选秀冠军背后资本运作内幕',
    summary: '据知情人士透露，该选手早在比赛前就已与多家娱乐公司签订秘密协议，选秀结果实为资本精心编排的一场大戏。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20with%20dramatic%20shadows%2C%20empty%20leather%20chairs%20around%20a%20long%20table%2C%20warm%20spotlight%20from%20above%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20deep%20amber%20and%20burgundy%20tones%2C%20power%20and%20secrecy%20theme%2C%20editorial%20photography&width=900&height=600&seq=deep-dive-featured&orientation=landscape',
    link: '/article/xuanxiu-ziben',
  },
  articles: [
    {
      id: 'deep-1',
      tag: '独家',
      title: '某平台头部主播涉嫌数据造假',
      subtitle: '后台真实数据曝光',
      image: 'https://readdy.ai/api/search-image?query=Digital%20data%20screens%20glowing%20in%20dark%20room%2C%20red%20and%20amber%20numbers%20on%20monitors%2C%20mysterious%20tech%20atmosphere%2C%20investigative%20mood%2C%20cinematic%20lighting%2C%20deep%20shadows%2C%20editorial%20style%2C%20no%20people&width=700&height=500&seq=deep-article-01&orientation=landscape',
      link: '/article/zhubo-shuju',
    },
    {
      id: 'deep-2',
      tag: '追踪',
      title: '网红情侣分手大战升级',
      subtitle: '双方各执一词互爆猛料',
      image: 'https://readdy.ai/api/search-image?query=Two%20broken%20picture%20frames%20on%20dark%20wooden%20floor%2C%20dramatic%20side%20lighting%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20emotional%20metaphor%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20rich%20burgundy%20undertones&width=700&height=500&seq=deep-article-02&orientation=landscape',
      link: '/article/qinglv-fenshou',
    },
    {
      id: 'deep-3',
      tag: '内幕',
      title: '某综艺节目导演组内斗曝光',
      subtitle: '节目背后不为人知的真相',
      image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20studio%20with%20dramatic%20lighting%2C%20empty%20director%20chairs%2C%20cables%20on%20floor%2C%20warm%20spotlight%20beams%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20deep%20amber%20tones%2C%20editorial%20style%2C%20no%20people&width=700&height=500&seq=deep-article-03&orientation=landscape',
      link: '/article/zongyi-neidou',
    },
  ],
};

export const testimonials = [
  {
    id: 'test-1',
    name: '吃瓜群众小王',
    role: '资深八卦爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20young%20person%2C%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20soft%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    quote: '51爆料是我每天的快乐源泉！更新速度超快，内容质量也很高，比其他八卦号靠谱多了。每次有大瓜都是在这里第一时间看到的。',
    type: 'text',
  },
  {
    id: 'test-2',
    name: '媒体人老李',
    role: '前娱乐记者',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20middle%20aged%20person%2C%20warm%20taupe%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20professional%20vibe&width=100&height=100&seq=avatar-02&orientation=squarish',
    quote: '做了十年娱记，我得说51爆料的信息源很硬。很多所谓的\"独家\"在这里能看到真实版本，推荐给所有关注娱乐圈的朋友。',
    type: 'text',
  },
  {
    id: 'test-3',
    name: '娱乐圈观察者',
    role: '微博大V @八卦早知道',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20portrait%20of%20stylish%20person%20in%20warm%20dramatic%20lighting%2C%20dark%20background%20with%20amber%20highlights%2C%20editorial%20fashion%20photography%2C%20mysterious%20mood%2C%20rich%20burgundy%20and%20gold%20tones%2C%20cinematic%20quality&width=800&height=600&seq=testimonial-photo-03&orientation=landscape',
    quote: '',
    type: 'photo',
  },
  {
    id: 'test-4',
    name: '深度吃瓜人',
    role: '忠实用户 3年',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20portrait%20with%20warm%20dramatic%20side%20lighting%2C%20half%20face%20in%20shadow%2C%20deep%20amber%20and%20burgundy%20contrast%2C%20cinematic%20composition%2C%20editorial%20style%2C%20investigative%20journalism%20vibe%2C%20rich%20texture&width=1400&height=900&seq=testimonial-photo-04&orientation=landscape',
    quote: '从大学开始就看51爆料，到现在工作三年了依然每天刷。这里的内容真实、有深度，不是那种标题党。希望越做越好！',
    type: 'photoLarge',
  },
  {
    id: 'test-5',
    name: '八卦研究生',
    role: '自媒体创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20creative%20person%2C%20warm%20cream%20and%20taupe%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20artistic%20vibe&width=100&height=100&seq=avatar-05&orientation=squarish',
    quote: '51爆料的深度追踪栏目做得太好了！每篇都像看侦探小说一样过瘾，而且有理有据，不是空穴来风。',
    type: 'textSmall',
  },
  {
    id: 'test-6',
    name: '理性吃瓜er',
    role: '产品经理',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20professional%20person%2C%20warm%20beige%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20thoughtful%20expression&width=100&height=100&seq=avatar-06&orientation=squarish',
    quote: '全网最敢说的爆料平台，不站队、不洗白，事实就是事实。这点在现在的网络环境里太难得了。',
    type: 'textSmall',
  },
];